import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import API from '../lib/api';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { KeyRound } from 'lucide-react';

export default function ChangePasswordPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState('');
  const [next, setNext]       = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error('New passwords do not match');
      return;
    }
    if (next.length < 8) {
      toast.error('Password must be at least 8 characters');
      return;
    }
    setLoading(true);
    try {
      await API.post('/auth/change-password', { current_password: current, new_password: next });
      toast.success('Password changed. Please sign in again.');
      logout();
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="w-full max-w-sm bg-white rounded-xl border shadow-sm p-8 space-y-5">
        <div className="text-center">
          <div className="w-12 h-12 rounded-xl bg-amber-100 flex items-center justify-center mx-auto mb-3">
            <KeyRound size={20} className="text-amber-600" />
          </div>
          <h2 className="text-lg font-bold">Change Your Password</h2>
          <p className="text-xs text-slate-500 mt-1">Your account requires a password change before continuing.</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <Label className="text-xs">Current Password</Label>
            <Input type="password" value={current} onChange={e => setCurrent(e.target.value)}
              className="mt-1 h-8 text-sm" required autoComplete="current-password" />
          </div>
          <div>
            <Label className="text-xs">New Password (min 8 characters)</Label>
            <Input type="password" value={next} onChange={e => setNext(e.target.value)}
              className="mt-1 h-8 text-sm" required autoComplete="new-password" />
          </div>
          <div>
            <Label className="text-xs">Confirm New Password</Label>
            <Input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
              className="mt-1 h-8 text-sm" required autoComplete="new-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-8 text-sm">
            {loading ? 'Saving…' : 'Set New Password'}
          </Button>
        </form>
      </div>
    </div>
  );
}
